import { useCallback, useEffect, useState } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';

export const useGetReports = (surv) => {
  const survId = surv?.id;
  // console.log('survId', survId);
  const [listState, setListState] = useState({
    isLoading: false,
    report: [],
    error: null,
  });

  const getReport = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const { data } = await BraveBupAPI.get(`/reports?surveyId=${survId}`);
      const report = data || [];
      setListState((prevState) => ({
        ...prevState,
        report,
      }));
    } catch (error) {
      console.log('useGetReport error', error);
      setListState((prevState) => ({
        ...prevState,
        error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [setListState, survId]);

  useEffect(() => {
    if (survId) getReport();
  }, [getReport, survId]);

  return {
    isLoadingReport: listState.isLoading,
    report: listState.report,
    errorReport: listState.error,
  };
};
